import FileCopyIcon from '@/images/FileCopy.svg';
import { useAgentEditorStore } from '@/state/root';
import theme from '@/theme';
import styled from '@emotion/styled';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';

const StyledCopyButton = styled(Button)<{ hidden: boolean }>`
    position: absolute;
    top: 16px;
    right: 20px;
    background: ${theme.colors.secondary.main};
    color: white;
    font-size: 14px;
    display: ${({ hidden }) => (hidden ? 'none' : 'block')};
    transition: transform 0.3s ease-in-out;
    &:hover {
        background: ${theme.colors.secondary[800]};
    }
    text-transform: capitalize;
    font-weight: 600;
    border-radius: 8px;
`;

const Text = styled('span')`
    margin-left: 5px;
`;

const Container = styled.div`
    display: flex;
    align-items: center;
`;

interface Props {
    text: string;
    type: 'link' | 'code';
    isCopied?: boolean;
}

export const CopyButton = observer(({ text, type, isCopied }: Props) => {
    const agentEditorStore = useAgentEditorStore();

    const copyToClipboard = async (text: string) => {
        await navigator.clipboard.writeText(text);
        if (type === 'code') {
            agentEditorStore.setIsCodeSnippetCopied(true);
        }
    };

    return (
        <StyledCopyButton onClick={() => copyToClipboard(text)} hidden={false}>
            {isCopied ? (
                <Text>Copied!</Text>
            ) : (
                <Container>
                    <img src={FileCopyIcon} width="18px" height="18px" />
                    <Text>Copy</Text>
                </Container>
            )}
        </StyledCopyButton>
    );
});
